import { ECrmType } from '@webtrader/core/enum/crm';
import { TLang } from '@webtrader/core/i18n';

import { ELoginConfigType, EMainProductCodeType } from '../config/company';

export interface IWallet {
  id: string;
  balance: number;
  currency: string;
}

export enum EAccountType {
  LIVE = 'LIVE',
  MASTER = 'MASTER',
  VIRTUAL = 'VIRTUAL'
}

export enum EAccountDisplayType {
  DEMO = 'DEMO',
  LIVE = 'LIVE',
  MASTER = 'MASTER',
  VIRTUAL = 'VIRTUAL'
}

export enum ESimple2TradeAccountType {
  DEMO = 'DEMO',
  LIVE = 'LIVE',
  COPY_F = 'COPY_F',
  COPY_M = 'COPY_M',
  MAM = 'MAM',
  PAMM = 'PAMM',
  INV = 'INV'
}

export enum EBaseCurrency {
  USD = 'USD',
  EUR = 'EUR',
  THB = 'THB'
}

export enum ETradingState {
  NEUTRAL = 'NEUTRAL',
  MARGIN_CALL = 'MARGIN_CALL',
  STOPPED_OUT = 'STOPPED_OUT'
}

export const CurrencySymbol: Record<EBaseCurrency, string> = {
  [EBaseCurrency.USD]: '$',
  [EBaseCurrency.EUR]: '€',
  [EBaseCurrency.THB]: '฿'
};

export interface ITradingAccount {
  accountId: number;
  userId: number;
  userGroup: string;
  accountName: string;
  accountNumber: number;
  baseCurrency: EBaseCurrency;
  isDemo: boolean;
  platform: string;
  isVirtual: boolean;
  // realizedPL: number;
  // unRealizedPL: number;
  strategy: string;

  // balance value
  balance: number;
  margin: number;
  equity: number;
  profitLoss: number;
  freeMargin: number;
  marginCall: number;
  marginLevel: number;
  marginStopout: number;
  // centroid value
  notional?: number;
  commission?: number;
  swaps?: number;
  availableWithdraw?: number;
  credit?: number;
  tradingState?: ETradingState;

  traderId: string;
  traderSubscription: string;
  marketSubscription: string;
  metatraderId: number;
  accountType: EAccountType;
  accountDisplayType: EAccountDisplayType;
  accountTypeName: string;
  simple2TradeAccountType: ESimple2TradeAccountType;
  canSwitch: boolean;
  selected: boolean;
  enable: boolean;
  language: TLang;
  leverage?: number;
  oneClickTradingEnabled: boolean;
  dealer: boolean;
  omsServerId: string;
  serverId: number;
  mainProductCode: EMainProductCodeType;
}

export interface IUserProfile {
  tradingAccounts: ITradingAccount[];
  crmType: ECrmType;
  loginConfig: ELoginConfigType;
  notificationTopics: string[];
}
